export const fields = [
  {
    dataIndex: "label",
    key: "label",
    title: "菜单系统名称",
    isShow: true,
  },
  // {
  //   dataIndex: "menuName",
  //   key: "menuName",
  //   title: "菜单名称",
  //   width: 180,
  // },
  {
    dataIndex: "orderNum",
    key: "orderNum",
    title: "排序",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "status",
    key: "status",
    title: "菜单状态",
    width: 180,
    isShow: true,
    scopedSlots: {
      customRender: "MenuTag",
    },
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 150,
    isShow: true,
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const slotOpt = [
  {
    slot: "MenuTag",
    component: "MenuTag",
    list: [
      {
        name: "开放",
        color: "blue",
        cb: "normal",
      },
      {
        name: "隐藏",
        color: "purple",
        cb: "banned",
      },
    ],
  },
  {
    slot: "action",
    component: "Action",
    list: [{ name: "配置", cb: "configMenu", divider: false }],
  },
];
